import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  row: {
    display: "flex",
    flexDirection: "row",
    height: "100%"
  },
  start: {
    justifyContent: "flex-start"
  },
  center: {
    justifyContent: "center"
  },
  end: {
    justifyContent: "flex-end"
  },
  around: {
    justifyContent: "space-around"
  },
  between: {
    justifyContent: "space-between"
  },
  top: {
    alignItems: "flex-start"
  },
  middle: {
    alignItems: "center"
  },
  bottom: {
    alignItems: "flex-end"
  },
  wrap: {
    flexWrap: "wrap"
  }
});

const getStyleFuncs = classes => ({
  getHorizontal: props => {
    if (props.start) {
      return classes.start;
    } else if (props.center) {
      return classes.center;
    } else if (props.end) {
      return classes.end;
    } else if (props.around) {
      return classes.around;
    } else if (props.between) {
      return classes.between;
    }
    return classes.start;
  },
  getVertical: props => {
    if (props.top) {
      return classes.top;
    } else if (props.middle) {
      return classes.middle;
    } else if (props.bottom) {
      return classes.bottom;
    }
    return classes.top;
  },
  getWrap: props => {
    if (props.wrap) {
      return classes.wrap;
    }
    return;
  }
});

const Row = ({ classes, children, ...rest }) => {
  const styler = getStyleFuncs(classes);
  const computedStyle = [
    classes.row,
    styler.getHorizontal(rest),
    styler.getVertical(rest),
    styler.getWrap(rest)
  ].join(" ");
  return (
    <div className={computedStyle} rest>
      {children}
    </div>
  );
};

Row.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  start: PropTypes.bool,
  center: PropTypes.bool,
  end: PropTypes.bool,
  around: PropTypes.bool,
  between: PropTypes.bool,
  top: PropTypes.bool,
  middle: PropTypes.bool,
  bottom: PropTypes.bool
};

export default injectSheet(styles)(Row);



// WEBPACK FOOTER //
// ./src/components/Grid/Row.jsx